package com.zq.webproject

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.*
import com.zq.webproject.ui.home.ECommerceHomeScreen
import com.zq.webproject.ui.register.QRCodeRegisterScreen
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * 应用主入口
 * 根据URL参数决定显示注册页面还是首页
 */
@Composable
@Preview
fun App() {
    MaterialTheme {
        // 获取URL参数（仅Web平台有效）
        val invitationCode = getInvitationCodeFromUrl()
        var showRegister by remember { mutableStateOf(!invitationCode.isNullOrEmpty()) }
        
        if (showRegister) {
            // 显示扫码注册页面
            QRCodeRegisterScreen(
                invitationCode = invitationCode,
                onRegisterSuccess = {
                    // 注册成功后跳转到首页
                    println("App - 注册成功，跳转到首页")
                    showRegister = false
                },
                onBack = {
                    // 返回首页
                    println("App - 返回首页")
                    showRegister = false
                }
            )
        } else {
            // 显示电商首页
            ECommerceHomeScreen()
        }
    }
}

/**
 * 从URL获取邀请码参数
 * 期望URL格式: http://localhost:8081/?inviteCode=ABC123
 * 
 * 注意：这个函数在commonMain中定义，但实际实现在各平台的expect/actual中
 * Web平台会从 window.location.search 获取
 * 其他平台返回 null
 */
@Composable
expect fun getInvitationCodeFromUrl(): String?